import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyTuple = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Tuple in Python</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this easy tutorial, we will learn about Tuple in Python.
                    Here, we will discuss how to create, access, slice, insert,
                    update and delete elements from Python Tuple with example.
                    <br />
                    <br />A Tuple in Python is a sequence of different objects,
                    different objects mean different types of data can be store
                    in a Tuple. The Tuple in Python is similar to a List but
                    Tuples are immutable type so, we can’t change the value of a
                    tuple.
                  </p>
                </div>
                <br />
                <br />

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <h1 className="py_h1">How to Create Tuple</h1>
                  <p>
                    To create a tuple in Python, you need places all the items
                    inside round brackets ( ) separated by comma(,).
                  </p>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>How to Create a Tuple</h3>
                  </div>

                  <pre>
                    <code>
                      {`
                     #Empty Tuple
                     n=()
                      
                     #Tuple with numbers
                     n=(11, 22, 33, 44, 55)
                      
                     #Tuple with Text
                     n=("Red", "Green", "Yellow")
                      
                     #Tuple with mixed objects
                     n=(11, 22, "Hello", [2,4,6])
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">A Tuple with Single Element </h1>

                <hr style={{ color: "white" }} />
                <p>
                  A Tuple with single element must end with a comma (,), whether
                  it is inside or outside round brackets
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #without comma it will treated as a normal object.
                     X=(11)
                     Y=11
                     print(type(X))
                     print(type(Y))
                      
                     #create a tuple with single element.
                     X=(11,)
                     Y=11,
                     print(type(X))
                     print(type(Y))
                     #must be end with comma
                       `}
                    </code>
                  </pre>
                </div>

                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Access Element of the Tuple</h1>

                <hr style={{ color: "white" }} />
                <p>
                  Elements of the tuple are assigned a unique index number,
                  starting from 0. Negative indexing is also possible in Tuple,
                  the index of the last item is -1. We can access the element of
                  the tuple by referring index number in square [ ] brackets.
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #creating a tuple
                     n=(11, 22, 33, 44, 55)
                      
                     #print all items of the tuple
                     print(n)
                      
                     #print first item
                     print(n[0])
                      
                     #print third item
                     print(n[2])
                      
                     #print last item
                     print(n[-1])
                      
                     #print second last item
                     print(n[-2])
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Slicing Python’s Tuple</h1>

                <hr style={{ color: "white" }} />
                <p>
                  Slicing is also possible in the tuple to access sub-items. For
                  slicing the tuple we have to use colon ( : ) operator. Syntax
                  for slicing
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    [start : stop : step].
                  </span>
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #create a tuple
                     n=(11, 22, 33, 44, 55)
                      
                     #print all the elements
                     print(n)
                     print(n[:])
                       
                     #print first to third element (index 0 to 2)
                     print(n[0:3])
                       
                     #print element of index 1 to 2
                     print(n[1:3])
                       
                     #print element of index 2 to last
                     print(n[2:])
                       
                     #print element of index 1 to second last
                     print(n[1:-1])
                       
                     #print value of index (0,2,4)
                     print(n[0:5:2])
                       `}
                    </code>
                  </pre>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Loop Through a Tuple</h3>
                  </div>
                  <p>We can loop through a tuple using a for a loop.</p>
                  <pre>
                    <code>{`
                        #create a tuple
                        num=(11, 22, 33, 44, 55)
                        for i in num:
                            print(i)
                             
                        #all the item of the tuple will assign to variable i, until the last item. 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Update Tuple in Python</h1>

                <hr style={{ color: "white" }} />
                <p>
                  As we know tuples are immutable, so we can’t update or change
                  elements of the tuple. However, if the elements of the tuple
                  are mutable than we can edit the elements or we can create new
                  tuple based upon existing two tuples.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        #creating a tuple
                        n=(11, 22, 33, 44, 55)
                        #n[0]=10     #error, we can't change
                         
                         
                        #-----------------------------------
                        n=(11, 22, 33, [1, 2])
                        #item of the mutable element can be changed.
                        n[3][0]=99
                        print(n)
                        #output : (11, 22, 33, [99, 2])
                         
                         
                        #-----------------------------------
                        t1=(1, 2, 3)    #tuple 1
                        t2=(99, 88, 77)     #tuple 2
                         
                        #we can concatenate two tuples using + operator
                        t3 = t1 + t2
                        print(t3)
                        #output : (1, 2, 3, 99, 88, 77)
                         
                        #-----------------------------------
                        n=(11, 22, 33, 44, 55)
                        #tuple can be reassign
                        n=(1, 2, 3, 4, 5)
                        print(n)
                        #output : (1, 2, 3, 4, 5) 
                        `}</code>
                  </pre>
                  <br />
                </div>
                <div className="row mt-4">
                  <h1 className="py_h1">Delete a Tuple</h1>

                  <hr style={{ color: "white" }} />
                  <p>
                    As we discussed, a tuple is immutable, it means we can’t
                    remove an item from the tuple. But we can delete entire
                    tuple using the del keyword.
                  </p>
                  <div className="col-md-3"></div>
                  <div className="col-md-6" style={{ color: "white" }}>
                    <div
                      // className="bg-info"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#5d7b89",
                        fontFamily: "Fira Mono",

                        fontWeight: "bolder",
                      }}
                    >
                      <h3>Example</h3>
                    </div>
                    <pre>
                      <code>{`
                        n=[11, 22, 33, 44, 55]
                        print(n)
                         
                        #using extend() method
                        list1=[1, 2, 3]
                        n.extend(list1)
                        print(n)
                         
                        #output : [11, 22, 33, 44, 55, 1, 2, 3] 
                        `}</code>
                    </pre>
                  </div>
                  <div className="col-md-3"></div>
                </div>
                <div className="row mt-3">
                  <h1 className="py_h1">Useful Functions of the Tuple</h1>

                  <hr style={{ color: "white" }} />

                  <div className="col-md-3"></div>
                  <div className="col-md-6" style={{ color: "White" }}>
                    <ul>
                      <li>count() – Return count of an item in the tuple.</li>
                      <li>
                        index() – It returns the index of the first matching
                        item.
                      </li>
                    </ul>
                    <div
                      // className="bg-info"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#5d7b89",
                        fontFamily: "Fira Mono",

                        fontWeight: "bolder",
                      }}
                    >
                      <h3>Example</h3>
                    </div>
                    <pre>
                      <code>{`
                        n=(11, 22, 11, 88, 33, 11, 55)
                        print(n)
                         
                        #count an item in the list
                        print(n.count(11))
                         
                        #return index of 33 in the list
                        print(n.index(33)) 
                        `}</code>
                    </pre>
                  </div>
                  <div className="col-md-3"></div>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
